import {
  put, takeEvery,
} from 'redux-saga/effects';
import { select } from '~/_shared/utils/saga/effects';
import { BOUNDARY_TERRITORY_GROUP_FETCH_SUCCESS } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.actionTypes';
import { mapToolChanged } from '~/store/frontendState/leftSidebar/leftSidebar.actionCreators';
import { MAP_RESET } from '~/store/map/map.actionTypes';
import { MAP_SETTINGS_READY_SET } from '~/store/mapSettings/ready/mapSettingsReady.actionTypes';
import { areMapSettingsReadySelector } from '~/store/mapSettings/ready/mapSettingsReady.selectors';
import { activeToolChanged } from './mapSettingsToolsStateActiveTool.actionCreators';
import { activeToolSelector } from './mapSettingsToolsStateActiveTool.selectors';
import type { MapSettingsToolsStateActiveTool } from './mapSettingsToolsStateActiveTool.state';

// The single place that detects changes of the active tool, so that the reactions to it do not have to track it themselves
export function* mapSettingsToolsStateActiveToolSagas() {
  let previousTool: MapSettingsToolsStateActiveTool | null = null;

  yield takeEvery(MAP_RESET, function resetPreviousTool() {
    // the saga lives for the whole app lifecycle, so the tool must not leak from one map to another
    previousTool = null;
  });

  yield takeEvery([
    mapToolChanged,
    MAP_SETTINGS_READY_SET,
    BOUNDARY_TERRITORY_GROUP_FETCH_SUCCESS, // while the tool is not set explicitly, it is determined from the content of the Boundary tool
  ], function* onActiveToolMayHaveChanged() {
    const areMapSettingsReady: boolean = yield select(areMapSettingsReadySelector);

    if (!areMapSettingsReady) {
      return; // MAP_SETTINGS_READY_SET will bring us back
    }

    const newTool: MapSettingsToolsStateActiveTool = yield select(activeToolSelector);

    if (newTool !== previousTool) {
      const oldTool = previousTool;
      previousTool = newTool;
      yield put(activeToolChanged(newTool, oldTool));
    }
  });
}
